import { StatusConfig } from './Badge';
import { AgentStatus, WorkflowStatus, IntegrationStatus } from '../../model';

export const agentStatusConfigs: Record<string, StatusConfig> = {
  [AgentStatus.START]: {
    label: 'Start',
    className: 'start',
  },
  [AgentStatus.AWAITING_FILE_UPLOAD]: {
    label: 'Awaiting File Upload',
    className: 'awaiting',
  },
  [AgentStatus.AWAITING_BEHAVIOUR]: {
    label: 'Awaiting Behaviour',
    className: 'awaiting',
  },
  [AgentStatus.READY]: {
    label: 'Ready',
    className: 'ready',
  },
  default: {
    label: 'Unknown',
    className: 'default',
  },
};

export const workflowStatusConfigs: Record<string, StatusConfig> = {
  [WorkflowStatus.ACTIVE]: {
    label: 'Active',
    className: 'active',
  },
  [WorkflowStatus.INACTIVE]: {
    label: 'Inactive',
    className: 'inactive',
  },
  default: {
    label: 'Unknown',
    className: 'default',
  },
};

export const integrationStatusConfigs: Record<string, StatusConfig> = {
  [IntegrationStatus.ACTIVE]: {
    label: 'Active',
    className: 'active',
  },
  [IntegrationStatus.INACTIVE]: {
    label: 'Inactive',
    className: 'inactive',
  },
  default: {
    label: 'Unknown',
    className: 'default',
  },
};
